/**
 * @file duePicker.js
 * @location src/components/modals/taskform/duePicker.js
 * @role 기한 picker 공용 헬퍼 — 빠른 프리셋(오늘/내일/-주) + native date input 열기.
 *   TaskModalStep2·TaskDetailHeaderEdit 공용. 마크업 레이아웃은 각 모달이 보유(-- 차이).
 */
import { getTodayStr, weekStart, addDays } from '../../../utils/dateUtils';

/** @returns {[string, string][]} [라벨, YYYY-MM-DD] 쌍 — 오늘 / 내일 / -주(주 시작) */
export function duePresetOptions() {
  const t = getTodayStr();
  return [['오늘', t], ['내일', addDays(t, 1)], ['다음 주', weekStart(new Date(`${addDays(t, 7)}T00:00:00`))]];
}

/** native <input type=date> 의 showPicker() 호출 (미지원·차단 시 focus 폴백). */
export function openNativeDatePicker(el) {
  if (el?.showPicker) { try { el.showPicker(); return; } catch { /* fallback */ } }
  el?.focus();
}
